// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"ProgressBar_progressBar_1XRDy","progress":"ProgressBar_progress_1l1-3","totalTime":"ProgressBar_totalTime_dMeYV","currentTime":"ProgressBar_currentTime_1roDF"};